export const DEFAULT_LANGUAGE = 'English'

/**
 * Returns the given language, defaulting `null`, `undefined`, or empty
 * strings to `'English'` (assets with no language are reported as English).
 */
export const formatLanguage = (language?: string | null): string => {
  return language?.trim() || DEFAULT_LANGUAGE
}
